module.exports = __webpack_public_path__ + "img/_Smokey.82fefa51.png";